import Icon from "~/components/ui/Icon"
import Slider from "~/components/ui/Slider"
import SliderJS from "~/components/ui/SliderJS"
import { useId } from "react"
import Image from "~/components/ui/Image"
import type { Benefits } from "./Resale"

export interface Props {
    benefits?: Benefits
    isMobileDevice: boolean
}

export default function Benefits({ benefits, isMobileDevice = false }: Props) {
    if (!benefits || !benefits.items) return null

    const sliderID = useId()

    return (
        <div className='bg-black/50 lg:h-40 lg:relative'>
            <div className='max-w-[1810px] px-3 mx-auto grid justify-items-center md:h-40 md:mt-32 md:grid-cols-[max-content_1fr] md:items-end md:content-end md:gap-10'>
                {isMobileDevice
                    ? (
                        <div
                            id={sliderID}
                            className='max-w-md mx-auto grid items-center relative md:h-40'
                        >
                            <Slider className='carousel carousel-center my-5 items-center'>
                                {benefits.items.map((image, index) => (
                                    <Slider.Item
                                        className='carousel-item w-full justify-center shrink-0'
                                        index={index}
                                    >
                                        <Image
                                            className='w-max h-20 object-contain'
                                            {...image}
                                            width={250}
                                            height={83}
                                            loading='lazy'
                                        />
                                    </Slider.Item>
                                ))}
                            </Slider>

                            <Slider.PrevButton className='absolute top-1/2 left-0 -translate-y-1/2'>
                                <Icon
                                    id='ChevronLeft'
                                    className='text-[#f071ad]'
                                    width={52}
                                    height={90}
                                    strokeWidth={5}
                                />
                            </Slider.PrevButton>

                            <Slider.NextButton className='absolute top-1/2 right-0 -translate-y-1/2'>
                                <Icon
                                    id='ChevronRight'
                                    className='text-[#f071ad]'
                                    width={52}
                                    height={90}
                                    strokeWidth={5}
                                />
                            </Slider.NextButton>

                            <SliderJS rootId={sliderID} interval={3000} />
                        </div>
                    )
                    : (
                        <div className='w-full h-40 grid grid-cols-5 justify-items-center items-center gap-8'>
                            {benefits.items.map((image) => (
                                <Image
                                    className='w-max h-full max-h-20 object-contain'
                                    {...image}
                                    width={196}
                                    height={83}
                                    loading='lazy'
                                />
                            ))}
                        </div>
                    )}

                {benefits.featuredImage && (
                    <Image
                        className='mt-10 object-cover md:col-start-1 md:row-start-1'
                        {...benefits.featuredImage}
                        width={261}
                        height={225}
                        loading='lazy'
                    />
                )}
            </div>
        </div>
    )
}
